import { render, staticRenderFns } from "./TableTitle.vue?vue&type=template&id=22a50ccc&scoped=true"
import script from "./TableTitle.vue?vue&type=script&lang=js"
export * from "./TableTitle.vue?vue&type=script&lang=js"
import style0 from "./TableTitle.vue?vue&type=style&index=0&id=22a50ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a50ccc",
  null
  
)

export default component.exports